import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import * as userService from '../admin/services/userService'

import Swal from "sweetalert2";
import { Password } from 'primereact/password';
import { passRegex } from '../utils/Validations';

export function ParentChangePass() {

    const { onLogout } = useContext(AuthContext);
    const navigate = useNavigate();



    const allcontext = useContext(AuthContext);
    const idp = allcontext.user.id;

    const [formData, setFormData] = useState({
        id: idp,
        oldPass: '',
        newPass: ''

    });

    document.title = `Смяна на парола`;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const onSubmit = (e) => {
        e.preventDefault();

        if (!passRegex.test(formData.newPass)) {
            Swal.fire({
                title: "Паролата трябва да съдържа поне 8 символа, включващи главни и малки букви, цифри и специален символ!",
                icon: "warning",
            });
            return;
        }

        if (formData.newPass === formData.oldPass) {
            Swal.fire({
                title: "Възникна грешка",
                text: 'Старата и новата парола не могат да съвпадат!',
                icon: "warning",
            });

            return;
        }

        userService.chpass(formData)
            .then(data => {
                onLogout();

                Swal.fire({
                    title: "Паролата е сменена успешно!",
                    text: '',
                    icon: "success",
                });

                navigate('/parent-login');
            })
            .catch((error) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: error.message,
                    icon: "warning",
                });
            });
    }

    return (
        <div>
            <div>
                <div className="title_entr">Смяна на парола</div>

                {/*<p>За да може да промените вашата забравена парола е необходимо да въведете следните данни , които сте попълнили при вече направената регистрация.</p>*/}

                <div className="d-flex flex-wrap justify-content-center">

                    <form className="form w-30 w-75-mob" id="login" method="post" action="login">




                        <div className="form-group ">
                            <div className="d-flex flex-wrap gap-4 change-pass  w-100-l">
                                <div className="input-group">
                                    <span className="p-float-label labels  w-100">
                                        <Password
                                            name='oldPass'
                                            value={formData.oldPass}
                                            onChange={handleChange}
                                            feedback={false}
                                            toggleMask
                                            className={`${formData.oldPass.length > 5 || formData.oldPass === '' ? '' : 'p-invalid'} w-100`}
                                        />
                                        <label htmlFor="oldPass">Стара парола *</label>
                                    </span>
                                </div>

                                <div className="input-group ">
                                    <span className="p-float-label labels">
                                        <Password
                                            name='newPass'
                                            value={formData.newPass}
                                            onChange={handleChange}
                                            feedback={false}
                                            toggleMask
                                            className={`${formData.newPass.length > 5 || formData.newPass === '' ? '' : 'p-invalid'} w-100`}
                                        />
                                        <label htmlFor="newPass">Нова парола *</label>

                                    </span>

                                </div>
                            </div>


                        </div>


                        <div className="form-group">

                            <div className="mt-3 text-end w-100">
                                <button type="submit" id="" className="btn btn-info btn-cust w-35" onClick={onSubmit}>Потвърди</button>
                            </div>

                        </div>




                    </form>

                </div>

            </div>
        </div>
    );
}

export default ParentChangePass;